export default __webpack_public_path__ + "static/media/CapaCheckCircle.4d1537f9.svg";